/**
 * Credential recovery (operator) — URL state and the names this feature uses for the
 * contract-generated wire shapes in api.generated.ts.
 */

import { z } from "zod";
import type { recoveryPassSchema, recoveryRequestSchema, recoveryRequestsPageSchema } from "./api.generated";

export type RecoveryRequest = z.infer<typeof recoveryRequestSchema>;
export type RecoveryRequestsPage = z.infer<typeof recoveryRequestsPageSchema>;
export type RecoveryRequestStatus = RecoveryRequest["status"];
export type RecoveryPass = z.infer<typeof recoveryPassSchema>;

export const RECOVERY_REQUEST_STATUSES = [
  "pending",
  "awaiting_info",
  "approved",
  "denied",
  "expired",
  "cancelled",
] as const satisfies ReadonlyArray<RecoveryRequestStatus>;

/** The request list's filter lives in the URL: a status, and the page the reader is on. */
export const recoveryRequestsSearchSchema = z.object({
  status: z.enum(RECOVERY_REQUEST_STATUSES).optional().catch(undefined),
  cursor: z.string().uuid().optional().catch(undefined),
});
export type RecoveryRequestsSearch = z.infer<typeof recoveryRequestsSearchSchema>;
